<mat-card class="info-card {{ cor }} mat-elevation-z0">
    <div class="card-content">
      <div class="card-title">{{ title }}</div>
      <div class="card-number">{{valuePrefixo}} {{ displayedValue | number:valueFormat }}{{valueSufixo}}</div>

      <mat-progress-bar
      *ngIf="progress !== null"
      mode="determinate"
      [value]="progress"
    ></mat-progress-bar>
      <div class="card-footer" *ngIf="footerText">
        <mat-icon *ngIf="footerIcon">{{ footerIcon }}</mat-icon>
        <span>{{ footerText }}</span>
      </div>
    </div>
    <mat-icon  class="background-icon">{{ backgroundIcon }}</mat-icon>

  </mat-card>